import React from "react";
interface EmbedOfflineMessageProps {
  isDisconnected: boolean;
  theme: "light" | "dark";
}

export function EmbedOfflineMessage({ isDisconnected, theme }: EmbedOfflineMessageProps) {
  const mutedTextColor = theme === "dark" ? "text-[#4fa935]" : "text-gray-600";

  return (
    <div className="text-center space-y-2">
      <div className="text-base font-bold">
        {isDisconnected ? "HOST DISCONNECTED" : "STATION OFFLINE"}
      </div>
      <div className={`text-sm ${mutedTextColor}`}>
        {isDisconnected
          ? "The broadcaster is reconnecting"
          : "This broadcast has ended. Check back later!"}
      </div>
      {/* Placeholder for future subscription button */}
      <div data-embed-subscribe-placeholder className="mt-4" />
    </div>
  );
}
